import { GeoPressureIntelligenceClientSandbox } from "@/components/globe/geo-pressure-intelligence-client-sandbox";
import { SiteNav } from "@/components/layout/site-nav";
import { useSearchParams } from "react-router-dom";
import {
  parseGeoPressureFilters,
  parseGlobeCameraUrlState,
} from "@/lib/gdelt-globe";
import { siteConfigRepository } from "@/repositories/site-config-repository";
import type { GlobeFrame, GlobeMapMode } from "@/types/gdelt";

export default function GeoPressureSandboxPage() {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());
  const siteConfig = siteConfigRepository.getSiteConfig();

  return (
    <>
      <SiteNav brand={siteConfig.brand} items={siteConfig.navigation} developerItems={siteConfig.developerNavigation} />
      <GeoPressureIntelligenceClientSandbox
        initialFrame={EMPTY_EXPORT_FRAME}
        initialFilters={parseGeoPressureFilters(params)}
        initialCameraState={parseGlobeCameraUrlState(params)}
        initialMapMode={getMapMode(params.mode)}
      />
    </>
  );
}

const EMPTY_EXPORT_FRAME: GlobeFrame = {
  generated_at: new Date(0).toISOString(),
  window_minutes: 15,
  global_intensity: 0,
  category_breakdown: { social_unrest: 0, crime: 0, corruption: 0, political_violence: 0, institutional_instability: 0 },
  zones: [],
};

function getMapMode(mode: string | string[] | undefined): GlobeMapMode {
  const value = Array.isArray(mode) ? mode[0] : mode;
  return value === "terrain" ? "terrain" : "outline";
}

